import { render, staticRenderFns } from "./TranslationsLocaleSelector.vue?vue&type=template&id=66184b22&scoped=true&"
import script from "./TranslationsLocaleSelector.vue?vue&type=script&lang=ts&"
export * from "./TranslationsLocaleSelector.vue?vue&type=script&lang=ts&"
import style0 from "./TranslationsLocaleSelector.vue?vue&type=style&index=0&id=66184b22&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66184b22",
  null
  
)

export default component.exports